export default [
  {
    component: () => import("@/components/controladoria/cenarios/form-cenarios-edit.vue"),
    name: "controladoria.cenarios.editar",
    label: "Editar Cenários de Custo",
    path: "/controladoria/editar-cenario/:id",
  },
  {
    component: () => import("@/components/controladoria/cenarios/cenarios.vue"),
    name: "controladoria.cenarios.gerenciar",
    path: "/controladoria/cenarios/gerenciar",
    label: "Visualizar Cenários de Custo",
  },
  {
    component: () => import("@/components/controladoria/cenarios/cenario-itens.vue"),
    name: "controladoria.cenarios.itens-editar",
    label: "Editar Custos Primários de Insumos",
    path: "/controladoria/cenarios/:id/itens",
  },
  {
    component: () => import("@/components/controladoria/cenarios/cenario-produtos.vue"),
    name: "controladoria.cenarios.produtos-editar",
    label: "Editar Custos Primários de Produtos",
    path: "/controladoria/cenarios/:id/produtos",
  },
  {
    component: () => import("@/components/controladoria/cenarios/home-cenarios.vue"),
    name: "controladoria.cenarios",
    path: "/controladoria/cenarios",
    label: "Cenários de Custo",
  },
  {
    component: () => import("@/components/controladoria/relatorios/home-relatorios.vue"),
    name: "controladoria.relatorios",
    path: "/controladoria/relatorios",
    label: "Relatórios",
  },
  {
    component: () => import("@/components/home/MenuControladoria.vue"),
    name: "controladoria",
    path: "/controladoria",
    label: "Controladoria",
  },
  {
    component: () => import("@/components/controladoria/cenarios/form-cenarios.vue"),
    name: "controladoria.cenarios.novo",
    label: "Criar Cenários de Custo",
    path: "/controladoria/cenarios/novo",
  },
  {
    component: () => import("@/components/controladoria/relatorios/rentabilidade.vue"),
    name: "controladoria.relatorios.rentabilidade",
    path: "/controladoria/relatorios/rentabilidade",
    label: "Relatório de Rentabilidade",
  },
  {
    component: () => import("@/components/controladoria/relatorios/rastreamento-produtos.vue"),
    name: "controladoria.relatorios.rastreamento-produtos",
    path: "/controladoria/relatorios/rastreamento-produtos",
    label: "Relatório de Rastreamento de Produtos",
  },
  {
    component: () => import("@/components/controladoria/relatorios/rastreamento-materia-prima.vue"),
    name: "controladoria.relatorios.rastreamento-materia-prima",
    path: "/controladoria/relatorios/rastreamento-materia-prima",
    label: "Relatório de Rastreamento de Insumos",
  },
];
